import { useEffect, useContext } from "react"
import { useLocation } from "react-router-dom"
import { UserCtx } from "../../context/userContext"

const Tracker = () => {
  const location = useLocation()
  const { user } = useContext(UserCtx)

  const isDev = process.env.REACT_APP_DEV_ENV === "true"

  const loadLeadDynoScript = () => {
    return new Promise<void>((resolve, reject) => {
      const script = document.createElement("script")
      script.src = "https://static.leaddyno.com/js"
      script.async = true
      script.defer = true

      script.onload = () => resolve()
      script.onerror = (error) => {
        console.error("Error loading LeadDyno script:", error)
        reject(error)
      }

      document.head.appendChild(script)
    })
  }

  useEffect(() => {
    if (isDev) return

    loadLeadDynoScript()
      .then(() => {
        if (window.LeadDyno) {
          window.LeadDyno.key = process.env.REACT_APP_PUBLIC_LEADDYNO_KEY

          if (!user) {
            window.LeadDyno.recordVisit()
            window.LeadDyno.autoWatch()
          }
        }
      })
      .catch(() => {
        console.error("Failed to load LeadDyno script")
      })
  }, [])

  useEffect(() => {
    if (isDev) return

    if (window.LeadDyno) {
      window.LeadDyno.recordVisit(() => {})
    }
  }, [location.pathname])

  return null
}

export default Tracker
